module.exports = __webpack_public_path__ + "static/media/street-glide-special-black.bd71aa7f.png";